const formatRiverName = (river) => {
  if (!river) return ''
  return river.endsWith('その他') ? '' : river
}

export function useCustomMeta(page, name, river) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = `${config.public.hostDomain}${config.app.baseURL}`
  const pageUrl = `${baseUrl}${route.fullPath.replace(/^\//, '')}`
  const tdConfig = () => {
    switch (page) {
      case 'top': {
        return {
          title: '河川水位情報【平常時の様子と比較】',
          description: '【河川レーダー｜ウェザーニュース】河川水位のリアルタイムな現在の様子を、観測所の水位計とライブカメラで確認できます。過去データも掲載中。気象庁が国土交通省や都道府県と共同して発表する、氾濫情報などの洪水予報の発表状況を地図一覧で見られます。最新の気象・防災情報は予報精度No.1ウェザーニュースで。',
          keyword: '河川水位,ライブカメラ,ウェザーニュース'
        }
      }
      case 'river': {
        return {
          title: `${name}の河川水位情報`,
          description: `【${name}の河川レーダー｜ウェザーニュース】${name}（${river}）の河川水位情報。リアルタイムな現在の様子と平常時の様子を一覧で確認できます。観測所の水位計とライブカメラ、過去データを掲載中。気象庁が国土交通省や都道府県と共同して発表する、氾濫情報などの洪水予報の発表状況を地図で見られます。`,
          keyword: `${name},河川水位,ライブカメラ`
        }
      }
      case 'obscam': {
        return {
          title: `${name}の河川水位情報`,
          description: `【${name}のリアルタイム河川水位情報】${formatRiverName(river)}${name}の現在と平常時の様子を比較できる河川ライブカメラを掲載しています。過去データのグラフで水位の変化を確認。気象庁が国土交通省や都道府県と共同して発表する、氾濫情報などの洪水予報の発表状況を確認できます。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
          keyword: `${name},河川水位,ライブカメラ`
        }
      }
      case 'cam': {
        return {
          title: `${name}の河川水位情報`,
          description: `【${name}のリアルタイム河川水位情報】${formatRiverName(river)}${name}の現在と平常時の様子を比較できる河川ライブカメラを掲載しています。気象庁が国土交通省や都道府県と共同して発表する、氾濫情報などの洪水予報の発表状況を掲載しています。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
          keyword: `${name},河川水位,ライブカメラ`
        }
      }
      case 'obs': {
        return {
          title: `${name}の河川水位情報`,
          description: `【${name}のリアルタイム河川水位情報】${formatRiverName(river)}${name}の現在の水位と過去データをグラフで確認できます。気象庁が国土交通省や都道府県と共同して発表する、氾濫情報などの洪水予報の発表状況を掲載しています。最新の気象情報は予報精度No.1ウェザーニュースで。`,
          keyword: `${name},河川水位`
        }
      }
    // No default
    }
  }
  useSeoMeta({
    ogImage: 'https://gvs.weathernews.jp/common/images/ogp/river@1x.png',
    ogType: 'website',
    ogSiteName: 'ウェザーニュース',
    viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    fbAppId: '1500388770270212',
    appleItunesApp: 'app-id=302955766',
    appleMobileWebAppCapable: 'yes',
    formatDetection: 'address=no'
  })
  useSeoMeta({
    title: `${tdConfig().title} - ウェザーニュース`,
    description: tdConfig().description,
    ogTitle: `${tdConfig().title} - ウェザーニュース`,
    ogDescription: tdConfig().description,
    ogUrl: pageUrl,
    appleMobileWebAppTitle: tdConfig().title,
    keywords: tdConfig().keyword
  })
  useHead({
    link: [
      { rel: 'preconnect', href: config.public.siteDataDomain, crossorigin: 'anonymous' },
      { rel: 'preconnect', href: 'https://aplapi.weathernews.jp', crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: config.public.siteDataDomain },
      { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp' },
      { rel: 'dns-prefetch', href: 'https://gis.weathernews.jp' },
      { rel: 'dns-prefetch', href: 'https://aplapi.weathernews.jp' },
      { rel: 'dns-prefetch', href: 'https://rivercam.weathernews.jp' }
    ]
  })
  if (route.params.rvrsys) {
    if (route.params.rvrsys in pageConfig) {
      useHead({
        link: [
          { rel: 'canonical', href: `${baseUrl}${route.params.rvrsys}/` }
        ]
      })
    }
  } else {
    useHead({
      link: [
        { rel: 'canonical', href: baseUrl }
      ]
    })
  }
}
